"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePickerDayBox = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _DatePickerDay = require("../components/DatePickerDay");
var _DateRangePickerDialog = require("../components/DateRangePickerDialog");
var _DatePickerDayBox = require("./DatePickerDayBox");
var _datePickerTheme = require("./datePickerTheme");
const shouldForwardProp = propName => {
  switch (propName) {
    case "rangeIsSelected":
    case "isInRange":
    case "isStart":
    case "isEnd":
    case "isDisabled":
    case "themeMode":
      // Just add any extra props here :)
      return false;
  }
  return true;
};
const DateRangePickerDayBox = (0, _styled.default)(_DatePickerDayBox.DatePickerDayBox, {
  shouldForwardProp
})("position: relative;", _ref => {
  let {
    isInRange
  } = _ref;
  return isInRange ? "border-radius: 0;" : "";
}, _ref2 => {
  let {
    isStart,
    isEnd,
    themeMode
  } = _ref2;
  switch (_datePickerTheme.datePickerTheme.dateRangeLimitBorderFlatteningType(themeMode)) {
    case "button":
      {
        // For Lodestar, we want to flatten the border radius on the first and last days of the range so
        // the corners abut the highlight of the selected range.
        return {
          ...(isStart ? {
            [`& .${_DatePickerDay.DAY_STYLED_CLASS_NAME}`]: {
              borderBottomRightRadius: 0,
              borderTopRightRadius: 0
            }
          } : {}),
          ...(isEnd ? {
            [`& .${_DatePickerDay.DAY_STYLED_CLASS_NAME}`]: {
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0
            }
          } : {})
        };
      }
    case "background":
      {
        // For Ursa, we want to add a bit of background to the left or right of the button so the
        // start/end days mesh well with the highlight range between them.
        return {
          // Saturdays and the last day of the month have rounded right corners
          [`:nth-of-type(7n), &.${_DateRangePickerDialog.DAY_END_OF_MONTH_CLASS_NAME}`]: {
            borderTopRightRadius: _datePickerTheme.datePickerTheme.borderRadius(themeMode),
            borderBottomRightRadius: _datePickerTheme.datePickerTheme.borderRadius(themeMode)
          },
          // Sundays and the first day of the month have rounded left corners
          [`:nth-of-type(7n + 1), &.${_DateRangePickerDialog.DAY_START_OF_MONTH_CLASS_NAME}`]: {
            borderTopLeftRadius: _datePickerTheme.datePickerTheme.borderRadius(themeMode),
            borderBottomLeftRadius: _datePickerTheme.datePickerTheme.borderRadius(themeMode)
          },
          // We'll use a pseudo-element to render the background and shift it left or right
          // depending on if we're looking at the start or end of the range.
          "::before": isStart || isEnd ? {
            content: `""`,
            position: "absolute",
            height: "100%",
            width: "50%",
            backgroundColor: _datePickerTheme.datePickerTheme.dateRangePickerInRangeBackgroundColor.selected(themeMode)
          } : {},
          // Attach it to the right side if it's the start of the range (unless it's Saturday)
          "&:not(:nth-of-type(7n))::before": isStart && {
            right: 0
          },
          // Attach it to the left side if it's the end of the range (unless it's Sunday)
          "&:not(:nth-of-type(7n+1))::before": isEnd && {
            left: 0
          }
        };
      }
  }
},
// If there is a range selected, we'll render a different background color.
_ref3 => {
  let {
    isDisabled,
    isInRange,
    rangeIsSelected,
    themeMode
  } = _ref3;
  return {
    backgroundColor: isInRange && !isDisabled ? rangeIsSelected ? _datePickerTheme.datePickerTheme.dateRangePickerInRangeBackgroundColor.selected(themeMode) : _datePickerTheme.datePickerTheme.dateRangePickerInRangeBackgroundColor.inProgress(themeMode) : undefined
  };
});
exports.DateRangePickerDayBox = DateRangePickerDayBox;
//# sourceMappingURL=DateRangePickerDayBox.js.map